import { Component, Input, OnInit } from "@angular/core";
import { DashboardVisitorService } from "../dashboard-visitor.service";

@Component({
	selector: "caass-visitor-denied",
	templateUrl: "./visitor-denied.component.html",
	styleUrls: ["./visitor-denied.component.css"],
})
export class VisitorDeniedComponent implements OnInit {
	constructor(private dashboardService: DashboardVisitorService) {}

	ngOnInit(): void {
		this.loadVisitorLog();
	}

	ngOnChanges() {
		this.loadVisitorLog();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() FacilityID: any;

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedVisitorLog: any;
	lstVisitorLog: any = [];

	//Filter lists
	lstScanStation: any = [];
	lstFacilityLocationCD: any = [];
	lstFacilityLocationName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "LogDT", header: "Date/Time" },
		{ field: "ScanStation", header: "ScanStation" },
		{ field: "FacilityLocationCD", header: "Location Code" },
		{ field: "FacilityLocationName", header: "Location" },
		{ field: "Comment", header: "Comments" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadVisitorLog() {
		this.loading = true;

		this.lstVisitorLog = [];

		if (this.FacilityID == undefined || this.FacilityID <= 0) {
			this.loading = false;
			return;
		}

		var result = this.dashboardService.DeniedEntrySelectList(this.FacilityID);
		result.subscribe(
			(response) => {
				this.lstVisitorLog = response;

				//Load Data Filter Lists
				this.lstScanStation = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.ScanStation))).sort();
				this.lstFacilityLocationCD = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.FacilityLocationCD))).sort();
				this.lstFacilityLocationName = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.FacilityLocationName))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedVisitorLog = val.data;
	}
	onRowUnselect(val) {
		this.SelectedVisitorLog = null;
	}
	onRowDblClick(VisitorLog) {
		this.SelectedVisitorLog = VisitorLog;
	}
	////////////////////////////////////////////
}
